<template>
  <div class="welfare">
    <div class="auto clearfix">
      <h3>专微寻影，粉丝福利！</h3>
      <p class="shai">晒出你的EOS R系列产品外观和拍摄作品，便有机会获得丰厚好礼！</p>
      <div class="content">
        <!-- 排行 -->
        <div class="ranking">
          <img src="../assets/image/rankingtitle.jpg" class="title" alt />
          <!-- <span class="font">每日 10:00,22:00 数据更新</span> -->
          <!-- <span class="font2">more ></span> -->
          <el-table :data="tableData" height="835px" stripe style="width: 429px">
            <el-table-column prop="order" label="排行" width="150"></el-table-column>
            <el-table-column prop="member.name" label="用户名" width="300">
              <template slot-scope="scope">
                <el-image class="tx" style="width: 45px; height: 45px" :src="scope.row.member.url"></el-image>
                <span class="mz" style="margin-left: 15px">{{scope.row.member.name}}</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="move">
            <el-button
              type="primary"
              id="cliMove"
              class="cliMove"
              :loading="loa"
              @click="load"
            >点击查看排行详情</el-button>
          </div>
        </div>
        <!-- 奖品设置 -->
        <div class="Prize">
          <img src="../assets/image/prize_title.jpg" class="title" />
          <div class="list_prize">
            <div class="list_li">
              <img src="../assets/image/icon1.jpg" class="letImg" />
              <div class="rightFont">
                <h3>好礼一：集赞赢好礼</h3>
                <p>发布与佳能专微EOS R、 EOS RP、RF镜头相关晒开箱、秀样片、给点评。按要求集赞获得佳友在线专业摄影背心。</p>
              </div>
            </div>
            <div class="list_li">
              <img src="../assets/image/icon2.jpg" class="letImg" />
              <div class="rightFont">
                <h3>
                  好礼二：
                  <br />获赞排行 胜者为王
                </h3>
                <p>活动截止后，帖子获赞数量排名前十位参与影友将有机会获得500元现金奖励获奖人不重复。</p>
              </div>
            </div>
            <div class="list_li">
              <img src="../assets/image/icon3.jpg" class="letImg" />
              <div class="rightFont">
                <h3>
                  好礼三：
                  <br />终极评选 赢万元大奖
                </h3>
                <p>活动最后，由佳友在线编辑部进行评选，对集满30个赞并且符合评选标准的帖子进行最终评选。评选出：最佳开箱奖1名、最佳样片奖1名、最佳点评奖1名。每个终极大奖的获胜者将获得价值万元的佳能专微系列产品。</p>
              </div>
            </div>
            <a
              href="http://bbs.photofans.cn/thread-1334424-1-1.html"
              target="_blank"
              class="move_click"
            >详情请见细则 ></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loa: false,
      tableData: []
    };
  },
  props: {
    delay2: {
      type: Boolean
    }
  },
  methods: {
    load() {
      this.$emit("disblock");
      this.loa = !this.loa;
      setTimeout(() => {
        this.loa = !this.loa;
      }, 500);
    }
  },
  created() {
    console.log("测试请求！");
    axios
      .get("/ajax/act_tj.php?page=1")
      .then(res => ((this.tableData = res.data), console.log(this.tableData)));
  }
};
</script>
<style scoped>
.welfare {
  float: left;
  width: 100%;
  min-width: 1000px;
  height: 1410px;
  background: url(../assets/image/welfare_bj.jpg) no-repeat center;
}
.auto {
  margin: 0 auto;
  max-width: 1300px;
  min-width: 1000px;
}
h3 {
  float: left;
  /* margin-top: 55px; */
  width: 100%;
  text-align: center;
  font-size: 60px;
  color: #cdb05d;
  font-weight: bold;
}
.shai {
  float: left;
  width: 100%;
  text-align: center;
  font-size: 30px;
  color: #000;
  margin-top: 30px;
}
.content {
  float: left;
  width: 100%;
  height: 1135px;
  margin-top: 90px;
}
.ranking {
  position: absolute;
  float: left;
  width: 429px;
  height: 1135px;
  background: #fff;
}
.ranking .font {
  position: absolute;
  top: 112px;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 14px;
  color: #333;
}
.ranking .font2 {
  position: absolute;
  top: 112px;
  right: 0;
  font-size: 14px;
  color: #333;
  cursor: pointer;
}
.ranking .font2::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 1px;
  border-bottom: 1px solid transparent;
  background: transparent;
  transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -ms-transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
}
.ranking .font2:hover::after {
  border-color: #333;
  width: 100%;
}
.ranking .title {
  float: left;
  width: 100%;
}
.el-table td .tx {
  /* display: inline-block; */
  float: left;
  margin-left: 0;
  width: 45px;
  border-radius: 50%;
}
.el-table td .mz {
  float: left;
  height: 51px;
  line-height: 51px;
  max-width: 155px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 20px;
  color: #333;
}
.el-table th > .cell {
  position: relative;
  text-align: left;
  word-wrap: normal;
  text-overflow: ellipsis;
  padding-left: 54px;
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.move {
  position: relative;
  float: left;
  width: 100%;
  height: 42px;
  margin-top: 45px;
}
.move #cliMove {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 0;
  /* margin-left: -98px; */
  /* width: 159px; */
  height: 42px;
  margin: 0 auto;
  background: transparent;
  font-size: 22px;
  color: #8c7f7f;
  border-top-left-radius: 50px;
  border-bottom-left-radius: 50px;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
  border-color: #e8e8e8;
  font-size: 16px;
  line-height: 9px;
}
/* -----------------奖品设置-------------------- */
.Prize {
  float: right;
  width: 850px;
  height: 100%;
  background: #fff;
}
.Prize .title {
  float: left;
  width: 100%;
}
.list_prize {
  float: left;
  width: 796px;
  padding-top: 50px;
  padding-left: 48px;
  padding-right: 20px;
}
.list_li {
  float: left;
  width: 100%;
  margin-bottom: 80px;
}
.list_li:last-child {
  margin: 0;
}
.letImg {
  float: left;
}
.rightFont {
  float: right;
  width: 612px;
}
.rightFont h3 {
  margin-top: 15px;
  margin-bottom: 10px;
  text-align: left;
  font-size: 34px;
  color: #000;
  line-height: 48px;
  font-weight: normal;
}
.rightFont p {
  float: left;
  width: 580px;
  color: #757575;
  font-size: 20px;
  line-height: 36px;
}
.move_click {
  float: left;
  text-decoration: none;
  color: #000;
  font-size: 16px;
}
</style>